const semanticClassNames = {
  root: 'tabs',
  menuContainer: 'tabs__menu-container',
  tabContainer: 'tabs__container',
  scrollButton: 'tabs__scroll-button',
  menuItem: 'tabs__item',
} as const;

export default semanticClassNames;
